import React from 'react';
import { MeetingProgress } from '../../../api/control.dao';
import './progress-dot-indicator.scss';
import classnames from 'classnames';
import * as mobxReact from 'mobx-react';


const ProgressDotIndicator = mobxReact.observer((props: { currentProgress: MeetingProgress }) => {

    const currentProgress = props.currentProgress || MeetingProgress.STANDBY;

    const statusKey = (statusName: MeetingProgress) => {
        return Object.values(MeetingProgress).indexOf(statusName);
    };

    const activeItem = (meetingProgressType: MeetingProgress) => statusKey(currentProgress) >= statusKey(meetingProgressType);

    return (<div className='progress-dot-wrapper'>
            {Object.values(MeetingProgress).slice(1).map(item =>
                <div
                    className={classnames('dot', {'dot--active': activeItem(item)})}
                    title={item}
                    key={item}
                />)
            }
        </div>
    );
});

export { ProgressDotIndicator };
